import { Component } from '@angular/core';
import {ICellRendererParams} from "ag-grid-community";
import {AgRendererComponent} from "ag-grid-angular";
import { SubscriptionBusinessService } from 'src/app/account/services/subscription-business.service';
import { NS_SubscriptionService } from 'src/app/shared/namespaces';
import { get } from 'lodash-es';

@Component({
    selector: 'app-subscriptions-action-renderer',
    template: `
      <div class="action-container">
        <button class="download-button" *ngIf="actionType == subscriptionBusinessService.subscriptionsActionRenderTypeEnum.invoiceDownload" mat-flat-button (click)="onActionClick($event, subscriptionBusinessService.subscriptionsActionRenderTypeEnum.invoiceDownload)">
          PDF<mat-icon>get_app</mat-icon>
        </button>
        <button *ngIf="actionType == subscriptionBusinessService.subscriptionsActionRenderTypeEnum.invoiceView" mat-icon-button (click)="onActionClick($event, subscriptionBusinessService.subscriptionsActionRenderTypeEnum.invoiceView)">
          View
        </button>
      </div>
    `,
    styles: [
      `
        .action-container {
          display: flex;
          justify-content: space-between;
        }
        .action-container .download-button {
          background: #EFF2FA;
        }
        ::ng-deep .action-container .download-button .mat-button-wrapper {
          display: flex;
          align-items:center;
          gap: 0.625rem;
        }
        ::ng-deep .action-container .download-button .mat-button-wrapper .mat-icon {
          height: auto;
          margin-top: 0;
        }
      `
    ]
  })
  export class SubscriptionsActionRenderComponent implements AgRendererComponent{
    constructor(public subscriptionBusinessService: SubscriptionBusinessService) {

    }
    public params: ICellRendererParams;
    actionType: NS_SubscriptionService.SubscriptionsActionRenderTypeEnum;
    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.actionType = get(params,['actionType'], NS_SubscriptionService.SubscriptionsActionRenderTypeEnum.invoiceDownload);        
    }
    
    refresh(): boolean {
        return false;
    }

    onActionClick(event, action: NS_SubscriptionService.SubscriptionsActionRenderTypeEnum) {
      event.stopPropagation()
        switch(action) {
            case NS_SubscriptionService.SubscriptionsActionRenderTypeEnum.invoiceDownload:
                this.params.context.componentParent.downloadInvoices(this.params.data.description);
                break;
            case NS_SubscriptionService.SubscriptionsActionRenderTypeEnum.invoiceView:
                this.params.context.componentParent.viewInvoices(this.params.data.description);
                break;
        }
    }
    
  }